// extracted by mini-css-extract-plugin
module.exports = {"cartTaxAndDuties":"CartTaxAndDuties_cartTaxAndDuties__694tv"};